export default __webpack_public_path__ + "static/media/FAC9.9695a8ff.jpg";